var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldMusicSquareSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.07 21.04a3.576 3.576 0 0 0-2.99-5.54c-1.98 0-3.58 1.6-3.58 3.58a3.576 3.576 0 0 0 5.54 2.99l.72.72a.728.728 0 0 0 1.03-1.03l-.72-.72zM11.488 12.81c0 .41.33.74.74.74s.74-.33.74-.74-.33-.74-.74-.74-.74.33-.74.74zM6.02 13.799c0 .41.33.74.74.74s.74-.33.74-.74-.33-.74-.74-.74-.74.33-.74.74z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2c-.28 0-.55.01-.81.05-3.15.29-5 2.4-5 5.76v8.38c0 3.36 1.85 5.47 5 5.76.26.04.53.05.81.05h5.69c.39 0 .64-.44.49-.8-.29-.69-.49-1.49-.49-2.2 0-3.03 2.47-5.5 5.5-5.5.76 0 1.5.15 2.18.45.37.16.82-.09.82-.49V7.81C22 4.17 19.83 2 16.19 2H7.81zm6.67 10.81c0 .01-.01.02-.01.04a2.243 2.243 0 0 1-2.24 2.21c-1.24 0-2.24-1.01-2.24-2.24 0-1.24 1.01-2.24 2.24-2.24.26 0 .51.05.75.14V9.03l-3.97 1.08v3.7c0 .01-.01.02-.01.03a2.234 2.234 0 0 1-2.24 2.2c-1.24 0-2.24-1.01-2.24-2.24a2.25 2.25 0 0 1 2.24-2.24c.26 0 .51.05.74.14V7.79c0-.93.58-1.68 1.47-1.92l2.98-.82c.93-.25 1.5 0 1.82.24.46.35.69.92.69 1.68v1.08h.02v4.76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMusicSquareSearch);
export default __webpack_public_path__ + "static/media/vuesax-bold-music-square-search.83db5c45afd5587546a56757c5e42c44.svg";
export { ForwardRef as ReactComponent };